import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function ensure<T>(arg: T, error?: string | Error): NonNullable<T> {
  if (arg === null || arg === undefined) {
    if (error instanceof Error) {
      throw error
    }

    throw Error(error ?? 'Please ensure an argument is neither undefined nor null.')
  }

  return arg
}

export function assertNever(): never {
  throw Error('Exhaustiveness Error')
}

export function downloadBlob(blob: Blob, filename: string): void {
  const anchor = document.createElement('a')
  anchor.href = URL.createObjectURL(blob)
  anchor.download = filename
  anchor.click()
  URL.revokeObjectURL(anchor.href)
}
